import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FiltersContainerComponent } from './filters-container.component';
import { UserTableTopContainerComponent } from './user-table-top-container.component';
import { DisplayUserInfoComponent } from './display-user-info.component';
import { DisplayAccountComponent } from './display-account.component';
import { TableContainerComponent } from './table-container.component';
import { UserTableTitleContainerComponent } from './ui/user-table-title-container.component';

@NgModule({
  declarations: [
    FiltersContainerComponent,
    UserTableTopContainerComponent,
    DisplayUserInfoComponent,
    DisplayAccountComponent,
    TableContainerComponent,
    UserTableTitleContainerComponent,
  ],
  imports: [CommonModule, TranslateModule],
  exports: [
    FiltersContainerComponent,
    UserTableTopContainerComponent,
    DisplayUserInfoComponent,
    DisplayAccountComponent,
    TableContainerComponent,
    UserTableTitleContainerComponent,
  ],
})
export class UserTablesModule {}
